export default __webpack_public_path__ + "static/media/bayadLogo.acc0ce8a.svg";